import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { CbEnumToLabelModule } from '@app/shared/pipe/enum-to-label/enum-to-label.module';
import { CbSortByModule } from '@app/shared/pipe/sort-by/sort-by.module';
import { CbDasherModule, CbInfoMessageModule, CbInfoPopupModule, CbLoadingSpinnerModule } from 'cb-hub-lib';
import { FilterChipListComponent } from './filter-chip-list/filter-chip-list.component';

const EXPORTS = [
    FilterChipListComponent
];

@NgModule({
    declarations: [
        ...EXPORTS,
    ],
    exports: EXPORTS,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MatIconModule,
        MatFormFieldModule,
        MatChipsModule,
        MatCardModule,
        MatSortModule,
        MatListModule,
        MatSelectModule,
        MatButtonModule,
        CbLoadingSpinnerModule,
        CbInfoMessageModule,
        CbInfoPopupModule,
        CbEnumToLabelModule,
        CbSortByModule,
        CbDasherModule,
    ]
})

export class CbFilterChipsModule { }
